import { UsageCostRequestParams } from '../../../../hooks'
import { toArrayQueryParams } from '../../../../utils/toArrayQueryParams'
import { ReportFiltersValues } from '../useAnalyticsFiltersStore/types'
import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'

export const mapAnalyticsFiltersGetParams = (filters: ReportFiltersValues) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const params: UsageCostRequestParams = {
        'nodeIds[]': toArrayQueryParams(filters.node),
        commodityTypeId: toArrayQueryParams(filters.commodity) ?? '',
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
        'facilityIds[]': toArrayQueryParams(filters.facility),
        'providerIds[]': toArrayQueryParams(filters.provider ?? []),
        'contractIds[]': toArrayQueryParams(filters.contract),
        'panIds[]': toArrayQueryParams(filters.account ?? []),
        'tagIds[]': toArrayQueryParams(filters.tag),
        'usnAccountIds[]': toArrayQueryParams(filters.usn ?? []),
        'meterIds[]': toArrayQueryParams(filters.meter),
        unitOfMeasureId:
            toArrayQueryParams(filters.unitOfMeasureId ?? []) ?? '',
    }

    return params
}
